import { Button, Dialog } from "../components";

export function RecoveryEmailCheckoutDialog({
  open,
  busy,
  error,
  email,
  referralCode,
  onEmailChange,
  onReferralChange,
  onSubmit,
  onSkip,
  onClose,
}: {
  open: boolean;
  busy: boolean;
  error: string;
  email: string;
  referralCode: string;
  onEmailChange: (value: string) => void;
  onReferralChange: (value: string) => void;
  onSubmit: () => void;
  onSkip: () => void;
  onClose: () => void;
}) {
  return (
    <Dialog
      className="checkout-email-dialog"
      description="可以先留下邮箱。只有付款成功、权益到账后才会发送验证邮件。"
      dismissible={!busy}
      footer={
        <>
          <Button disabled={busy} form="checkout-email-form" type="submit">
            {busy ? "正在创建订单…" : "付款成功后绑定"}
          </Button>
          <button
            className="checkout-skip"
            disabled={busy}
            onClick={onSkip}
            type="button"
          >
            暂不绑定，直接去支付
          </button>
        </>
      }
      onClose={onClose}
      open={open}
      title="付款后绑定恢复邮箱？"
    >
      <form
        id="checkout-email-form"
        onSubmit={(event) => {
          event.preventDefault();
          onSubmit();
        }}
      >
        <span className="card-kicker">首次购买 · 可选</span>
        <label>
          <span>恢复邮箱</span>
          <input
            autoComplete="email"
            onChange={(event) => onEmailChange(event.target.value)}
            placeholder="you@example.com"
            required
            type="email"
            value={email}
          />
        </label>
        <label>
          <span>邀请码（可选）</span>
          <input
            autoComplete="off"
            maxLength={16}
            minLength={8}
            onChange={(event) =>
              onReferralChange(event.target.value.toUpperCase().slice(0, 16))
            }
            placeholder="朋友分享的 8–16 位代码"
            value={referralCode}
          />
          <small>新用户首笔 Bomana 1 年会员订单可为推荐人续费 30 天。</small>
        </label>
        {error ? (
          <div className="form-error" role="alert">
            {error}
          </div>
        ) : null}
        <small>不绑定也能购买；之后仍可用历史支付宝付款身份找回账号。</small>
      </form>
    </Dialog>
  );
}
